<template>
  <v-content>
    <v-container style="max-width: 1000px; background-color: white">
      <v-layout column :class="$vuetify.breakpoint.mdAndUp ? 'mx-5 px-5' : ''">
        <v-layout align-center>
          <v-layout column>
            <v-flex
              class="text-xs-left display-2 primary--text font-weight-bold mb-1"
            >
              Electronic Signature Policy
            </v-flex>
            <v-flex class="text-xs-left font-italic grey--text">
              Effective Date: January 1st, 2021
            </v-flex>
          </v-layout>
          <v-spacer />
          <v-flex xs2 class="hidden-xs-only">
            <v-layout
              align-center
              column
              class="mt-3"
              @click="goToSoraban"
              style="cursor: pointer"
            >
              <img
                :src="require('@/assets/logo-sharp.png')"
                style="height: 35px"
              />
              <p class="primary--text title font-weight-bold mt-2 ml-1">
                Soraban
              </p>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider class="separator mt-4" />
        <v-layout
          column
          v-for="section in sections"
          :key="section.id"
          class="text-xs-left"
        >
          <v-flex
            v-if="section.title"
            class="primary--text headline font-weight-bold mt-5"
          >
            {{ section.title }}
          </v-flex>
          <v-flex class="pre-formatted subheading">
            {{ section.body }}
          </v-flex>
          <v-layout column v-if="section.subsections" class="subheading my-2">
            <v-flex
              v-for="(subsection, index) in section.subsections"
              :key="index"
              class="my-2"
            >
              • {{ subsection }}
            </v-flex>
          </v-layout>
        </v-layout>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'ElectronicSignature',
  data() {
    return {
      sections: [
        {
          id: 0,
          body:
            'Please read this electronic signature policy before signing any document in Soraban. ',
        },
        {
          id: 1,
          title: 'Acceptance of Terms',
          body:
            'When you sign the engagement letter electronically through Soraban, you are confirming that you have read and agreed on the below terms.',
        },
        {
          id: 2,
          title: 'Intent To Sign',
          body:
            "When you click 'Yes' to the confirmation we ask when signing the engagement letter, you are giving your intent to sign. You may skip signing completely and message the firm that has sent you the engagement letter to modify the terms set by the engagement letter.",
        },
        {
          id: 3,
          title: 'Opt-Out Caluse',
          body:
            "We offer a way to print, sign, and upload the engagement letter if you wish to not sign electronically. The firm that sent you the engagement letter and Soraban will have access to the uploaded engagement letter, and will be used to prove that you've agreed to the terms on the engagement letter.",
        },
        {
          id: 4,
          title: 'Legal Binding',
          body:
            'When you sign the engagement letter electronically on Soraban, you agree that you are the individual (couple, if married and filing jointly) mentioned in the engagement letter. Your signature, if necessary, will be used for court. If you do not want your signature to be legal binding, please let us know through hello@soraban.com.',
        },
        {
          id: 5,
          title: 'Audit',
          body:
            'We use FullStory to track who is logged in and is signing the engagement letter. Your email is linked to your identity. If you do not want to be tracked, please let us know through hello@soraban.com.',
        },
        {
          id: 6,
          title: 'Privacy',
          body:
            'By signing your engagement letter electronically, you are letting your firm and Soraban view and use your signature to prove that you have read and signed the engagement letter.',
        },
        {
          id: 28,
          title: 'Contact',
          body: 'You may contact Company by email to hello@soraban.com.',
        },
      ],
    };
  },
  methods: {
    goToSoraban() {
      window.location.href = 'https://www.soraban.com';
    },
  },
};
</script>
<style lang="postcss" scoped>
.pre-formatted {
  white-space: pre-line;
}
</style>
